import styled from 'styled-components';

const CoverText = styled.div`
  font-size: 1em;
  color: lightgray;
  font-size: 32px;
`;

export default CoverText;



// WEBPACK FOOTER //
// ./src/components/CoverText.js